import { Pipe, PipeTransform } from '@angular/core';
import { Organization, Person } from '@shared/interfaces';

@Pipe({
  name: 'organizationsToPersons'
})
export class OrganizationsToPersonsPipe implements PipeTransform {

  transform(items: Organization[]): Person[] {
    if (!items || !items.length) { return; }

    return items.map(e => ({
      image: e.image,
      firstName: e.name,
      roles: [{
        id: -1,
        name: 'LABEL.ORGANIZATIONS'
      }]
    }));
  }

}
